// Every URL the web app calls, in one place (server routes use the same constants).
// Functions with an id: called with no argument they give the server's route pattern (":id").
export const ROUTES = {
  health: '/health',
  auth: {
    registerOptions: '/auth/register/options',
    registerVerify: '/auth/register/verify',
    loginOptions: '/auth/login/options',
    loginVerify: '/auth/login/verify',
    logout: '/auth/logout',
  },
  api: {
    me: '/api/me',
    live: '/api/live',
    pushKey: '/api/push/key',
    pushStatus: '/api/push/status',
    pushSubscribe: '/api/push/subscribe',
    pushUnsubscribe: '/api/push/unsubscribe',
    pushTest: '/api/push/test',
    clock: '/api/clock',
    settings: '/api/settings',
    shipments: '/api/shipments',
    nextSrb: '/api/shipments/next-srb',
    customers: '/api/customers',
    agents: '/api/agents',
    rfqs: '/api/rfqs',
    carriers: '/api/carriers',
    carrierRates: '/api/carrier-rates',
    quotations: '/api/quotations',
    documents: '/api/documents',
    messages: '/api/messages',
    vaultDates: '/api/vault-dates',
    vaultDateDone: '/api/vault-dates/done',
    finance: '/api/finance',
    activity: '/api/activity',
    cards: '/api/cards',
    cardDecide: (id = ':id') => `/api/cards/${id}/decide`,
    cardInstruct: (id = ':id') => `/api/cards/${id}/instructions`,
    attachments: '/api/attachments',
    attachmentUpload: '/api/attachments/upload',
    mailAttachments: '/api/attachments/from-mail',
    mailAttachmentSave: '/api/attachments/from-mail/save',
    tasks: '/api/tasks',
    brain: '/api/brain',
    brainWake: '/api/brain/wake',
    alarms: '/api/alarms',
    alarmTest: '/api/alarms/test',
    alarmDelete: (id = ':id') => `/api/alarms/${id}/delete`,
  },
  internal: {
    alarms: '/internal/alarms',
    alarm: (id = ':id') => `/internal/alarms/${id}`,
    alert: '/internal/alert',
    cards: '/internal/cards',
    cardStatus: (id = ':id') => `/internal/cards/${id}/status`,
    mailBody: '/internal/mail/body',
    mailSearch: '/internal/mail/search',
    mailDone: '/internal/mail/done',
    tasks: '/internal/tasks',
    task: (id = ':id') => `/internal/tasks/${id}`,
    instructions: '/internal/instructions',
    instructionAnswered: (id = ':id') => `/internal/instructions/${id}/answered`,
    mail: '/internal/mail',
    mailStatus: '/internal/mail/status',
  },
} as const;

/** Header that programs on the server use to reach /internal/* */
export const INTERNAL_KEY_HEADER = 'x-serb-key';
